import mitt from 'mitt';

const Bus = mitt();

export default Bus;